$(function () {

    //basic events ====================================================================================
    $("#forgotten-pass-side-menu").on("click", function() {
        $("#login-form").addClass("hidden");
        $("#forgotten-password").removeClass("hidden");
        $("#fregistration-form").addClass("hidden");
    });

    $("#registration-side-menu").on("click", function() {
        $("#login-form").addClass("hidden");
        $("#forgotten-password").addClass("hidden");
        $("#registration-form").removeClass("hidden");
    });

    $(".back-to-login").on("click", function() {
        $("#login-form").removeClass("hidden");
        $("#forgotten-password").addClass("hidden");
        $("#registration-form").addClass("hidden");
    });

    //login form =======================================================================================
    $("#login-btn").on("click", function() {
        let loginEmail = $("#login-email").val().trim();
        let loginPass = $("#login-pass").val().trim();
        let hasError = false;

        // Reset all error states
        $(".input-block").removeClass("error");
        $(".error-note").addClass("hidden");
        // Validate email input
        if (loginEmail === "") {
            $("#login-email").closest(".input-block").addClass("error");
            $(".error-note").removeClass("hidden").text("Полето не може да бъде празно");
            hasError = true;
        }

        // Validate password input
        if (loginPass === "") {
            $("#login-pass").closest(".input-block").addClass("error");
            $(".error-note").removeClass("hidden").text("Полето не може да бъде празно");
            hasError = true;
        }

        if (hasError) {
            return;
        }

        // If fields are filled, check credentials via AJAX
        processProfileForm('/user/check_credentials', {
            'alias': loginEmail,
            'password': loginPass
        }, $('#main-profile-menu'), function(data, wrapper, initiator) {
            if (data['success'] === 1) {
                $('#main-profile-menu form').submit();
            } else {
                displayLoginError();
            }
        }, this);
    });

    $("#login-email, #login-pass").on("focus", function() {
        // Remove error class from the input-block of the focused field
        $(this).closest(".input-block").removeClass("error");

        // Optionally clear error message only if both fields are filled
        let emailVal = $("#login-email").val().trim();
        let passVal = $("#login-pass").val().trim();
        if (emailVal !== "" && passVal !== "") {
            $(".error-note").addClass("hidden").text("");
        }
    });

    function displayLoginError() {
        // Add error class to both fields
        $("#login-email, #login-pass").each(function() {
            $(this).closest(".input-block").addClass("error");
        });

        // Show the first error message (you can improve it to show both if needed)
        $(".error-note").removeClass("hidden").text("Грешно потребителско име / e-mail или парола");
    }

    function processProfileForm(url, inputData, wrapper, callback, initiator) {
        var elem = $('.loader-profile');
        if (elem) {
            elem.css("display", "block");
        }
        $.post(url, inputData, function(data) {
            if (callback != null) {
                callback(data, wrapper, initiator);
            }
        }, 'json').always(function(data) {
            if (elem) {
                elem.css("display", "none");
            }
        });
    };


    //forgotten password=================================================================================
    $("#forgotten-pass-btn").on("click", function() {
        let resetEmail = $("#forgotten-pass-email").val().trim();
        let $inputBlock = $("#forgotten-pass-email").closest(".input-block");
        let $errorNote = $inputBlock.find(".error-note");

        // Reset errors
        $inputBlock.removeClass("error");
        $errorNote.addClass("hidden").text("");

        // Validate
        if (resetEmail === "") {
            $inputBlock.addClass("error");
            $errorNote.removeClass("hidden").text("Моля, въведете e-mail адрес.");
            return;
        }

        // Process AJAX form
        processProfileForm("/user/forgotten_password", {
            'email': resetEmail,
            'submit': 1
        }, $('#forgotten-pass-side-menu'), function(data, wrapper, initiator) {
            if (data['success'] === 1) {
                // Clear input and show confirmation
                $("#forgotten-pass-email").addClass("hidden");
                $("#forgotten-pass-email-label").addClass("hidden");
                $("#forgotten-pass-btn").addClass("hidden");
                $("#info_message").text("Успешно изпратихме линк за възстановяване, на посочения e-mail. *Ако не получиш e-mail от нас, провери СПАМ папката на cвоята поща. Според различните филтри, нашето писмо може да попадне и там.")
            } else {
                // Show backend validation error (e.g., invalid email format or not found)
                $inputBlock.addClass("error");
                $errorNote.removeClass("hidden").text("Невалиден или несъществуващ e-mail адрес.");
            }
        }, this);
    });
    $("#forgotten-pass-email").on("focus", function() {
        let $inputBlock = $(this).closest(".input-block");
        $inputBlock.removeClass("error");
        $inputBlock.find(".error-note").addClass("hidden").text("");
    });

    //register code=============================================================================================
    $("#register-btn").on("click", function() {
        let registrationEmail = $("#registration-email").val().trim();
        let termsCheck = $("#terms-checkbox");
        let emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(registrationEmail); // basic email regex
        let hasError = false;

        // Reset error states
        let $emailBlock = $("#registration-email").closest(".input-block");
        let $emailError = $emailBlock.find(".error-note");
        let $termsError = $(".input-group .error");

        $emailBlock.removeClass("error");
        $emailError.addClass("hidden").text("");
        $termsError.addClass("hidden");

        // Email required
        if (registrationEmail === "") {
            $emailBlock.addClass("error");
            $emailError.removeClass("hidden").text("Моля, въведете e-mail адрес.");
            hasError = true;
        }
        // Email format check
        else if (!emailValid) {
            $emailBlock.addClass("error");
            $emailError.removeClass("hidden").text("Невалиден e-mail формат.");
            hasError = true;
        }

        // Terms checkbox
        if (!termsCheck.is(":checked")) {
            $termsError.removeClass("hidden").text("Трябва да се съгласите с условията за ползване.");
            hasError = true;
        }

        if (hasError) {
            return;
        }

        // CAPTCHA check (if present)
        let captcha = ($('#g-recaptcha-response')[0]?.value || '');

        // Submit via AJAX
        processProfileForm('/user/register', {
            'email': registrationEmail,
            'agreedterms': termsCheck.is(':checked'),
            'g-recaptcha-response': captcha,
            'submitReg': 1
        }, $('#registration-side-menu'), function(data, wrapper, initiator) {
            if (data['success'] === 1) {
                // Clear form, disable button, show message
                $("#registration-email").val("");
                $("#terms-checkbox").prop("checked", false);
                $("#register-btn").prop("disabled", true);
                $emailError.removeClass("hidden validation-error").text("Успешна регистрация. Моля, провери пощата си.");
            } else {
                // Show backend message or generic error
                $emailBlock.addClass("error");
                $emailError.removeClass("hidden").text(data.message || "E-mail адресът вече съществува.");
            }
        }, this);
    });

    $("#registration-email").on("focus", function() {
        $(this).closest(".input-block").removeClass("error");
        $(this).siblings(".error-note").addClass("hidden").text("");
    });

    $("#terms-checkbox").on("change", function() {
        if ($(this).is(":checked")) {
            $(".input-group .error").addClass("hidden").text("");
        }
    });

});